import { z } from 'zod'

export const creditPreassignedRequestSchema = z.object({
  client: z.number(),
  productType: z.number(),
  model: z.number(),
  registerNumber: z.string(),
  imei: z.string(),
  cost: z.number(),
  isEnrolledMoreThan30Days: z.boolean().optional()
})

export type CreditPreassignedRequestDTO = z.infer<
  typeof creditPreassignedRequestSchema
>

export const creditPreassignedDetailSchema = z.object({
  id: z.number(),
  registerNumber: z.string(),
  imei: z.string(),
  cost: z.string(),
  additionalCost: z.string().nullable(),
  initialCash: z.string().nullable(),
  initialWallet: z.string().nullable(),
  initialTotal: z.string().nullable(),
  totalPayment: z.string().nullable(),
  extraPaymentCash: z.string().nullable(),
  extraPaymentWallet: z.string().nullable(),
  paymentByQuotes: z.string().nullable(),
  isBiometricVerify: z.boolean(),
  clientId: z.number(),
  clientName: z.string(),
  categoryId: z.number(),
  categoryName: z.string(),
  productTypeId: z.number(),
  productTypeName: z.string(),
  modelId: z.number(),
  modelName: z.string(),
  branchOfficeId: z.number(),
  branchOfficeName: z.string(),
  rentabilityId: z.number(),
  insuranceRentability: z
    .object({
      insuranceRentabilityId: z.number(),
      name: z.string().nullable(),
      percentage: z.string(),
      month: z.string(),
      type: z.literal('ASIGNAR')
    })
    .nullable()
})

export type CreditPreassignedDetailDTO = z.infer<
  typeof creditPreassignedDetailSchema
>

export const creditPreassignedCreatedSchema = z.object({
  id: z.number()
})
